export const TOAST_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

/**
 * Maps toastr types from react-redux-toastr to styles used by
 * ListGroups from react-bootstrap
 * @param {string} toastrType - type of react-redux-toastr toastr
 */
export const toastrTypeToStyle = (toastrType) => {
  switch (toastrType) {
    case 'info': return 'info';
    case 'success': return 'success';
    case 'warning': return 'warning';
    case 'error': return 'danger';
    default: return 'info';
  }
};


// WEBPACK FOOTER //
// src/helpers/toasts.js